import React from "react";
import {Col, Row} from "react-bootstrap";
import {
    SiPostman,
    SiVercel,
    SiWebstorm
} from "react-icons/si";
import { LiaAws } from "react-icons/lia";
import {FaCcStripe} from "react-icons/fa";

function Toolstack() {
    return (
        <Row style={{justifyContent: "center", paddingBottom: "50px"}}>
            <Col xs={4} md={2} className="tech-icons">
                <SiWebstorm/>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiPostman/>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <SiVercel/>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <LiaAws/>
            </Col>
            <Col xs={4} md={2} className="tech-icons">
                <FaCcStripe/>
            </Col>
        </Row>
    );
}

export default Toolstack;
